import { useState, useEffect } from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import { toast } from 'sonner';
import { apiGet, apiPost } from '../../lib/apiClient';

export const AIFeedback = ({ analysisId, skuId }) => {
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const checkFeedback = async () => {
      try {
        const data = await apiGet(`/api/ai/feedback/${analysisId}/${skuId}`);
        if (data.has_feedback) {
          setFeedback(data.feedback);
          setSubmitted(true);
        }
      } catch (e) {
        console.error('Failed to check feedback', e);
      }
    };
    checkFeedback();
  }, [analysisId, skuId]);

  const submitFeedback = async (type) => {
    setLoading(true);
    try {
      await apiPost('/api/ai/feedback', {
        analysis_id: analysisId,
        sku_id: skuId,
        feedback: type
      });
      setFeedback(type);
      setSubmitted(true);
      toast.success(type === 'positive' ? 'Thanks! Glad the classification was helpful.' : 'Thanks for the feedback. We\'ll improve!');
    } catch (e) {
      toast.error('Failed to submit feedback');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="flex items-center gap-2 text-xs text-slate-500">
        <span>Your feedback:</span>
        {feedback === 'positive' ? (
          <span className="flex items-center gap-1 text-emerald-600">
            <ThumbsUp className="w-3 h-3" /> Accurate
          </span>
        ) : (
          <span className="flex items-center gap-1 text-amber-600">
            <ThumbsDown className="w-3 h-3" /> Needs improvement
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <span className="text-xs text-slate-500">Was this accurate?</span>
      <div className="flex gap-1">
        <button
          onClick={() => submitFeedback('positive')}
          disabled={loading}
          className="p-1.5 rounded-lg hover:bg-emerald-50 text-slate-400 hover:text-emerald-600 transition-colors"
          title="Yes, accurate"
          data-testid="feedback-positive"
        >
          <ThumbsUp className="w-4 h-4" />
        </button>
        <button
          onClick={() => submitFeedback('negative')}
          disabled={loading}
          className="p-1.5 rounded-lg hover:bg-red-50 text-slate-400 hover:text-red-500 transition-colors"
          title="No, incorrect"
          data-testid="feedback-negative"
        >
          <ThumbsDown className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
